import { __decorate, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import template from './documents-overview-languages.component.html';
var DocumentsOverviewLanguagesComponent = (function () {
    function DocumentsOverviewLanguagesComponent() {
    }
    DocumentsOverviewLanguagesComponent.prototype.ngOnInit = function () {
        this.showLanguages = false;
        if (this.preSelectedLanguage) {
            this.selectedLanguage = this.preSelectedLanguage;
        }
    };
    DocumentsOverviewLanguagesComponent.prototype.toggleLanguages = function () {
        this.showLanguages = !this.showLanguages;
    };
    DocumentsOverviewLanguagesComponent.prototype.selectLanguage = function (language) {
        this.showLanguages = false;
        if (this.selectedLanguage === language) {
            return;
        }
        this.selectedLanguage = language;
        if (this.onLanguageChange) {
            this.onLanguageChange({ language: language });
        }
    };
    DocumentsOverviewLanguagesComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DocumentsOverviewLanguagesComponent.prototype, "languages", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DocumentsOverviewLanguagesComponent.prototype, "preSelectedLanguage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DocumentsOverviewLanguagesComponent.prototype, "languageIsEnglish", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], DocumentsOverviewLanguagesComponent.prototype, "onLanguageChange", void 0);
    DocumentsOverviewLanguagesComponent = __decorate([
        Component({
            selector: 'documentsOverviewLanguages',
            template: template,
        })
    ], DocumentsOverviewLanguagesComponent);
    return DocumentsOverviewLanguagesComponent;
}());
export { DocumentsOverviewLanguagesComponent };
